import {
  MainTaskPageHeader,
  mapTaskDetailsToFormData,
  NewQSetReviewTaskDetails,
  QSetReviewTaskFormProvider,
  useQSetReviewTask,
} from '@exam-management/qset-review-task-detail';
import { QSetReviewModalProvider } from '@exam-management/task-management';
import { Box } from '@shared/components';

export default function QSetReviewDetailsPage() {
  const { mainTaskDetail } = useQSetReviewTask();

  const initialValues = mapTaskDetailsToFormData(mainTaskDetail);

  return (
    <>
      <MainTaskPageHeader />
      <QSetReviewTaskFormProvider initialValues={initialValues}>
        <QSetReviewModalProvider>
          <Box sx={(theme) => ({ p: theme.spacing(6) })}>
            <NewQSetReviewTaskDetails />
          </Box>
        </QSetReviewModalProvider>
      </QSetReviewTaskFormProvider>
    </>
  );
}
